import React, { Component } from 'react';
import styled from '@emotion/styled';

const Div = styled.div`
  padding-left: ${props => (props.withGutters ? '1.5rem' : '0')};
  padding-right: ${props => (props.withGutters ? '1.5rem' : '0')};
  padding-top: ${props => (props.paddingTop0 ? '0' : '1.5rem')};
  padding-bottom: ${props => (props.paddingBottom0 ? '0' : '1.5rem')};
  background-color: ${props =>
    props.backgroundColor ? props.theme[props.backgroundColor] : 'white'};
  border-top: ${props => (props.borderTop0 ? '0' : 'solid 1px transparent')};
  border-bottom: solid 1px transparent;
  display: ${props => props.display ?? 'block'};
  text-align: ${props => props.textAlign ?? 'inherit'};
  @media print {
    background-color: transparent;
  }
`;

class MainColumnSlice extends Component {
  render() {
    return (
      <Div
        paddingBottom0={this.props.paddingBottom0}
        paddingTop0={this.props.paddingTop0}
        borderTop0={this.props.borderTop0}
        withGutters={this.props.withGutters}
        backgroundColor={this.props.backgroundColor}
        display={this.props.display}
        textAlign={this.props.textAlign}
      >
        {this.props.children}
      </Div>
    );
  }
}

export default MainColumnSlice;
